import React, { Component } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
//import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilder/FormBuilderFunctions/FieldProps';
import Wrp from '../../../hoc/Wrp/Wrp';
import $ from 'jquery';


class MultiSelect extends Component {

  
  onChangeFormInput = (data,option) =>{
   
  }
  render() {
    let filterObject = this.props.filterObject;

    const  {
      item,
      isMulti,
      section,
      className,
      validationForms,
    } = this.props;

    const animatedComponents = makeAnimated();
    const options =  {};
    const updateData = {
      section_index:'',
      itemIndex:'',
      item:item,
    }
    const attr = formFieldsAttributes(
      {...item,className:className
    },validationForms,e => this.onChangeFormInput(updateData,e,'MultiSelect'));

    let value = attr.value;
    let defaultValueOptions = [];
    let select2Options = [];
    //console.log(JSON.stringify(this.props.options + 'props.options'))
    if(this.props.options) {
      select2Options = this.props.options.map((item,index)=>{        
          return(
            {
              label:item.label,
              value:item.value,
            }
          )                  
      });
    }
    
    let valueGet = [];
    if(this.props.value){
      valueGet = this.props.value.map((item,ii) => {
        if(item.value!==''){
          return item;
        }
      })  
    }
    

    // console.log(select2Options);
    return (
      <Wrp>
      {
        filterObject.input_value_type ? 
        <Select 
          isMulti={isMulti}        
          options={select2Options}
          value={valueGet}
          onChange={e => this.props.handleChangeMultiple(e,this.props.attr1,this.props.attr6)}
          //value={defaultValueOptions}
          // components={animatedComponents}
          {...attr.fieldAttributes}
        />

        : null
      }
        
        

      </Wrp>
    );
  }
}

MultiSelect.defaultProps = {
  isMulti: true,
  className:''
}

export default MultiSelect;
